import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import FormHelperText from '@material-ui/core/FormHelperText';

class OutlinedSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      labelWidth: 0,
    };
  }

  componentDidMount() {
    this.setState({
      labelWidth: ReactDOM.findDOMNode(this.InputLabelRef).offsetWidth,
    });
  }

  render() {
    const {
      timezone,
      showErrorsInline,
      dispatch,
      style,
      label,
      options,
      selectStyle,
      input: { onChange, value },
      meta: { touched, error },
      ...other
    } = this.props;

    const showError = showErrorsInline || touched;

    return (
      <FormControl variant="outlined" style={this.props.style}>
        <InputLabel
          ref={ref => {
            this.InputLabelRef = ref;
          }}
        >
          {label}
        </InputLabel>
        <Select
          variant="outlined"
          input={<OutlinedInput labelWidth={this.state.labelWidth} />}
          error={!!(showError && error)}
          helperText={showError && error}
          value={value}
          onChange={onChange}
          style={{ textAlign: 'left', lineHeight: '17px', ...selectStyle }}
          {...other}
        >
          {this._renderOptions()}
          {this._renderChildren()}
        </Select>
        {showError &&
          error && <FormHelperText style={{ color: '#ff0000' }}>{error}</FormHelperText>}
      </FormControl>
    );
  }

  _renderOptions = () => {
    if (!this.props.options) return;

    return this.props.options.map(option => {
      return (
        <MenuItem key={`option_${option.value}`} value={option.value}>
          {option.label}
        </MenuItem>
      );
    });
  };

  _renderChildren = () => {
    if (this.props.options) return;

    return this.props.children;
  };
}

export default OutlinedSelect;
